import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";

export default function ModalInfoGEG() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1>Was bedeutet GEG / BEG?</h1>
            <p>
            Je kleiner der WLG ist, desto besser die Wärmedämmung. Für BEG-Bundesförderung müssen bessere Dämmwerte erreicht werden.
            </p>
            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

